/**
 * Store Cleanup Provider
 * Sets up store cleanup event listeners for the entire application
 */

import { useStoreCleanup } from "@/hooks/useStoreCleanup"

interface StoreCleanupProviderProps {
	children: React.ReactNode
}

export const StoreCleanupProvider: React.FC<StoreCleanupProviderProps> = ({ children }) => {
	// Setup store cleanup event listeners
	useStoreCleanup()

	return <>{children}</>
}
